export default __webpack_public_path__ + "static/media/bruecke.5681e45f.jpg";